import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn,
  OneToMany, ManyToOne, JoinColumn, AfterLoad, getManager,
} from 'typeorm';
import { IsOptional, IsInt } from 'class-validator';
import { Egb } from '../types';

import { Gestacao } from './Gestacao';
import { InformacaoParto } from './InformacaoParto';
import { Paciente } from './Paciente';
import { Usuario } from './Usuario';
import { ResultadoDeExame } from './ResultadoDeExame';
import { TIPO_SANG_ID } from '../constants';

@Entity({name: "internacoes"})
export class Internacao {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsInt()
  @IsOptional()
  gestacao_id?: number | null;

  @Column()
  local?: string;

  @Column()
  @IsOptional()
  quarto?: string;

  @Column()
  motivo?: string;

  @Column({
    type: 'enum',
    enum: Egb,
  })
  egb?: string;

  @Column()
  @IsOptional()
  datetime_agendamento?: Date | null;

  @Column()
  @IsOptional()
  datetime_internacao?: Date | null;

  @Column()
  @IsOptional()
  data_previsao_alta?: Date | null;

  @Column()
  @IsOptional()
  data_alta?: Date | null;

  @Column()
  @IsOptional()
  cancelled?: Date | null;

  @Column()
  @IsOptional()
  cancelled_by?: Date | null;

  @CreateDateColumn()
  @IsOptional()
  justificativa_cancelamento?: string | null;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  @IsOptional()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @ManyToOne(type => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @ManyToOne(type => Gestacao)
  @JoinColumn({ name: 'gestacao_id' })
  gestacao?: Gestacao;

  @ManyToOne(type => Usuario)
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(type => Usuario)
  @JoinColumn({ name: 'updated_by' })
  usuario_updated_by?: Usuario;

  @OneToMany(type => InformacaoParto, informacoes_parto => informacoes_parto.internacao, {
    cascade: ['update'],
  })
  informacoes_parto?: InformacaoParto[];
}
